import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import EditableAttribute from 'pages/Client/EditableAttribute';
import type { FC } from 'react';
import type { FollowUpConfigDraft } from 'services/types/followUpConfig';

interface BasicInformationSectionProps {
  followUpConfigDraft: FollowUpConfigDraft;
  isEditing: boolean;
  setFollowUpConfigDraft?: (followUpConfigDraft: FollowUpConfigDraft) => void;
  hideIdentifier?: boolean;
}

const BasicInformationSection: FC<BasicInformationSectionProps> = ({
  followUpConfigDraft,
  isEditing,
  setFollowUpConfigDraft,
  hideIdentifier = false,
}) => {
  return (
    <Card sx={{ mb: 1.5, boxShadow: 0, borderRadius: 0 }}>
      <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
        <Typography variant="h6" gutterBottom sx={{ mb: 1.5, fontWeight: 600 }}>
          Información Básica
        </Typography>
        <Grid container spacing={1.5}>
          {!hideIdentifier && (
            <Grid size={{ xs: 12, sm: 6 }}>
              <EditableAttribute
                label="Identificador"
                value={followUpConfigDraft.identifier}
                onChange={(e) => setFollowUpConfigDraft?.({ ...followUpConfigDraft, identifier: e.target.value })}
                disabled={!isEditing}
                type="text"
              />
            </Grid>
          )}
          <Grid size={{ xs: 12, sm: 6 }}>
            <EditableAttribute
              label="Activo"
              value={followUpConfigDraft.isActive}
              onChange={(e) => setFollowUpConfigDraft?.({ ...followUpConfigDraft, isActive: e.target.checked })}
              disabled={!isEditing}
              type="checkbox"
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default BasicInformationSection;
